import React, { FC } from 'react';
import { Sticker } from '../../../components/sticker/Sticker';
import { LawFirmSubHeader } from '../sub-header/LawFirmSubHeader';
import { LawFirmInfos } from '../../lawFirm.types';
import { CustomToastContainer } from '../../../components/toaster/CustomToastContainer';
import { PageNav } from '../../../components/page-nav/PageNav';
import { lawFirmNav } from '../lawFirmNav';
import { UniqueLawFirm } from './UniqueLawFirm';
import { LawFirmMobileBar } from '../sub-header/LawFirmMobileBar';
import {
  DomainFlattened,
  Juridiction,
  Ville,
} from '../../../entity/entity.types';
import { UserContextType } from '../../../user/user.types';
import { PageContainer } from '../../../components/page-container/PageContainer';
import { Page, PageLeft } from '../../../components/page/Page';

type Props = {
  lawFirmInfos: LawFirmInfos;
  accessPremium: UserContextType['accessPremium'];
  loggedIn: UserContextType['loggedIn'];
  experience: {
    domains: Array<DomainFlattened>;
    juridictions: Array<Juridiction>;
    villes: Array<Ville>;
    decisionCount: number;
  };
  loaded: boolean;
  allDecisionsLink: string;
};

export const UniqueLawFirmMain: FC<Props> = ({
  lawFirmInfos,
  accessPremium,
  loggedIn,
  experience,
  loaded,
  allDecisionsLink,
}) => (
  <>
    <Sticker anchor="add-watcher-law-firm" margin="law-firm-sub-header">
      {({ isVisible }) => (
        <LawFirmSubHeader isVisible={isVisible} lawFirmInfos={lawFirmInfos} />
      )}
    </Sticker>
    <CustomToastContainer />
    <div className="entity">
      <PageContainer>
        <Page>
          <PageLeft>
            <PageNav outline={lawFirmNav} newNav />
          </PageLeft>
          <UniqueLawFirm
            lawFirmInfos={lawFirmInfos}
            accessPremium={accessPremium}
            loggedIn={loggedIn}
            experience={experience}
            loaded={loaded}
            allDecisionsLink={allDecisionsLink}
          />
        </Page>
        <Sticker anchor="add-watcher-law-firm">
          {({ isVisible }) => (
            <LawFirmMobileBar
              isVisible={isVisible}
              lawFirmInfos={lawFirmInfos}
            />
          )}
        </Sticker>
      </PageContainer>
    </div>
  </>
);
